import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper";

export default class extends Controller {
  static get targets() {
    return ["search", "option", "addFolder", "newFolderName"]
  }

  static get values() {
    return {
      recordId: Number,
      recordUrl: String,
      folderManagementUrl: String,
      type: String,
    }
  }

  search() {
    const searchValue = this.searchTarget.value.toLowerCase()
    let anySameName = false

    this.optionTargets.forEach((option) => {
      let optionName = option.dataset.name.toLowerCase()
      if (optionName === searchValue) {
        anySameName = true
      }

      if (optionName.includes(searchValue)) {
        option.classList.remove("d-none")
      } else {
        option.classList.add("d-none")
      }
    })

    if (searchValue !== "" && !anySameName) {
      this.addFolderTarget.classList.remove("d-none")
      this.newFolderNameTarget.textContent = this.searchTarget.value
    } else {
      this.addFolderTarget.classList.add("d-none")
      this.newFolderNameTarget.textContent = ""
    }
  }

  addFolder() {
    if (this.addFolderTarget.classList.contains("d-none")) {
      return
    }

    const formElement = TempFormHelper.create(this.folderManagementUrlValue, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "record_id", this.recordIdValue)
      TempFormHelper.addHiddenInput(form, "folder_name", this.searchTarget.value)
    })

    formElement.addEventListener("turbo:submit-end", () => {
      this.searchTarget.value = ""
      this.addFolderTarget.classList.add("d-none")
      this.newFolderNameTarget.textContent = ""
      this.optionTargets.forEach((option) => {
        option.classList.remove("d-none")
      })
    })

    formElement.requestSubmit()
  }

  setFolder({ params: { folderId } }) {
    TempFormHelper.create(this.recordUrlValue, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, `${this.typeValue}_folder_id`, folderId)
    }).requestSubmit()
  }

  clearFolder() {
    TempFormHelper.create(this.recordUrlValue, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, `${this.typeValue}_folder_id`, "")
    }).requestSubmit()
  }
}
